import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../shared/AuthContext.tsx';

interface ItemNav {
  to: string;
  label: string;
  icon: string;
}

const icons: Record<string, string> = {
  'event_available': 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5',
  'add_circle': 'M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  'history': 'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  'qr_code': 'M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z',
  'dashboard': 'M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25a2.25 2.25 0 0 1-2.25-2.25v-2.25Z',
  'group': 'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z',
  'category': 'M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z M6 6h.008v.008H6V6Z',
  'business': 'M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3H21',
  'list_check': 'M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15a2.25 2.25 0 0 1 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z',
  'payments': 'M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z',
  'bar_chart': 'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z',
  'calendar_month': 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5',
  'clock': 'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  'check_circle': 'M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  'logout': 'M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9',
};

function SvgIcon({ d, className = 'h-5 w-5' }: { d: string; className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d={d} />
    </svg>
  );
}

const ROLES_LABEL: Record<string, string> = {
  admin: 'Admin',
  operador: 'Operador',
  cliente: 'Cliente',
  personal: 'Personal',
};

export function LayoutShell({
  titulo,
  items,
  accent = 'primario',
  homeTo,
  fabTo,
  ayudaTo,
  cuentaTo,
}: {
  titulo: string;
  items: ItemNav[];
  accent?: 'primario' | 'slate' | 'azul' | 'verde';
  homeTo?: string;
  fabTo?: string;
  /** Ruta del manual del módulo; si está, aparece el "?" en el header. */
  ayudaTo?: string;
  /** Ruta de "Mi cuenta" (cambio de contraseña); el avatar del header la abre. */
  cuentaTo?: string;
}) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const acentos: Record<string, { bg: string; text: string }> = {
    primario: { bg: 'bg-primario-400', text: 'text-primario-400' },
    slate: { bg: 'bg-slade-600', text: 'text-slade-600' },
    azul: { bg: 'bg-azul-400', text: 'text-azul-400' },
    verde: { bg: 'bg-verde-400', text: 'text-verde-400' },
  };
  const accentBg = acentos[accent]?.bg ?? 'bg-primario-400';
  const accentText = acentos[accent]?.text ?? 'text-primario-400';

  async function salir() {
    await logout();
    navigate('/login', { replace: true });
  }

  const homePath = homeTo ?? items[0]?.to ?? '/';
  const rolLabel = ROLES_LABEL[usuario?.rol ?? ''] ?? usuario?.rol ?? '';
  const inicial = (usuario?.email ?? '?').charAt(0).toUpperCase();

  return (
    <div className="flex min-h-full flex-col bg-superficie">
      {/* Header: marca a la izquierda, usuario arriba a la derecha */}
      <header className="glass-header sticky top-0 z-30 border-b border-borde/40">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-6 py-3">
          <Link to={homePath} className="flex items-center gap-3 no-underline">
            <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${accentBg} text-white font-extrabold text-sm shadow-sm`}>
              C
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-contorno">CONVOCA</p>
              <h1 className="text-sm font-bold text-neutro-800 leading-tight">{titulo}</h1>
            </div>
          </Link>

          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right leading-tight">
              <p className="text-sm font-bold text-neutro-800">{rolLabel}</p>
              <p className="text-xs text-neutro-400">{usuario?.email}</p>
            </div>
            {ayudaTo && (
              <Link
                to={ayudaTo}
                aria-label="Ayuda"
                title="Ayuda"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-contorno-var bg-white text-base font-bold text-neutro-600 no-underline hover:bg-superficie-100 transition-colors"
              >
                ?
              </Link>
            )}
            {cuentaTo ? (
              <Link
                to={cuentaTo}
                aria-label="Mi cuenta"
                title="Mi cuenta: cambiar contraseña"
                className={`flex h-10 w-10 items-center justify-center rounded-full ${accentBg} text-white text-sm font-bold ring-2 ring-white shadow-sm no-underline hover:opacity-90`}
              >
                {inicial}
              </Link>
            ) : (
              <div className={`flex h-10 w-10 items-center justify-center rounded-full ${accentBg} text-white text-sm font-bold ring-2 ring-white shadow-sm`}>
                {inicial}
              </div>
            )}
            <button
              onClick={salir}
              className="rounded-full border border-contorno-var bg-white px-3 py-1.5 text-xs font-semibold text-neutro-600 hover:bg-superficie-100 transition-colors"
            >
              Salir
            </button>
          </div>
        </div>
      </header>

      {/* Nav desktop */}
      <nav className="hidden md:block border-b border-borde/40 bg-white">
        <div className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-4 sm:px-6 py-2">
          {items.map((i) => {
            const activa = location.pathname === i.to || (i.to === homePath && (location.pathname === homePath || location.pathname === homePath + '/'));
            return (
              <Link
                key={i.to}
                to={i.to}
                className={`flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-semibold no-underline transition-colors ${
                  activa
                    ? `${accentBg} text-white`
                    : 'text-neutro-500 hover:bg-superficie-100 hover:text-neutro-700'
                }`}
              >
                <SvgIcon d={icons[i.icon] ?? icons['dashboard']} className="h-4 w-4" />
                {i.label}
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Main content */}
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 sm:px-6 py-6 pb-24 md:pb-6">
        <Outlet />
      </main>

      {/* Bottom nav (mobile) */}
      <nav className="bottom-nav md:hidden">
        {items.map((i) => {
          const activa = location.pathname === i.to || (location.pathname === homePath + '/' && i.to === homePath);
          return (
            <Link
              key={i.to}
              to={i.to}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 no-underline transition-colors ${
                activa ? accentText : 'text-neutro-400'
              }`}
            >
              <SvgIcon d={icons[i.icon] ?? icons['dashboard']} className="h-5 w-5" />
              <span className="text-[10px] font-medium">{i.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* FAB (mobile) */}
      {fabTo && (
        <Link
          to={fabTo}
          className={`fixed bottom-20 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full ${accentBg} text-white shadow-lg hover:opacity-90 transition-opacity md:hidden no-underline`}
        >
          <SvgIcon d="M12 4.5v15m7.5-7.5h-15" className="h-6 w-6" />
        </Link>
      )}

      {/* Footer (desktop) */}
      <footer className="hidden md:block px-6 py-4 text-center text-xs text-neutro-400 border-t border-borde/40 bg-white">
        CONVOCA · v0 · Fase 0
      </footer>
    </div>
  );
}

export function TarjetaPlaceHolder({ titulo, cuerpo }: { titulo: string; cuerpo: ReactNode }) {
  return (
    <section className="tarjeta">
      <h2 className="mb-3 text-lg font-semibold text-neutro-800">{titulo}</h2>
      <div className="text-sm text-neutro-600">{cuerpo}</div>
    </section>
  );
}
